import type React from "react";
import { ReactComponent as Svg } from "./assets/alert-triangle.svg";
import * as styles from "./Icon.module.scss";

type WarningProps = React.SVGProps<SVGSVGElement>;

export const Warning = ({ className, ...props }: WarningProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
